import { Roles } from './environment.model';

export const roles: Roles = {
    admin: 'Serviceconfigurator.Admin',
    default: 'Serviceconfigurator.Default',
    ecommerce: ['CUAR_Ecommerce-IMPORT_OFFERS', 'CUAR_Ecommerce-SHOW_OFFERS'],
};
